import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitPreferenceStep1Page } from './init-preference-step1';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitPreferenceStep1Page,
  ],
  imports: [
    IonicPageModule.forChild(InitPreferenceStep1Page),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitPreferenceStep1PageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-preference-step1/init-preference-step1.module.ts